export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100, 250, 500]

export const DEFAULT_PAGE_SIZE = 10

export const HOUSEHOLDS_QUERY_KEY = 'userLoginActivity.households'

export const DEFAULT_CONFIG = {
  defaultPageSize: DEFAULT_PAGE_SIZE
}

/** Default grid sort: lastLoginTimestamp descending (internal + grid use 'desc'). */
export const DEFAULT_GRID_SORT = [{ id: 'lastLoginTimestamp', desc: 'desc' }]
